// export type User = Omit<
//   CompanyUsersResponse,
//   "userProfile" | "createdAt" | "updatedAt" | "status"
// >;

import { OrgService } from "../constants/company-user";

export interface OrgData {
  createdAt: string;
  updatedAt: string;
  id: string;
  orgName: string;
  orgUrl: string;
  supportEmail: string;
  orgService: OrgService[];
  frontegg_tenantId: string;
  descope_tenantId: string;
  orgLogo: {
    containerName: string;
    fileName: string;
    key: string;
    url: string;
  };
  allowToUploadBackInsuranceCard: boolean;
  allowToCompleteCustomIntakeForm: boolean;
  allowToUploadFrontInsuranceCard: boolean;
  formURL?: string;
  formEmbeddedCode?: string;
  form: ParentForm[];

  //stripe related
  customerId: string;
  currentSubscriptionId: string;
  currentPlanId: string;
  adminSeats: number;
  enterpriseApprove: boolean;
  enterpriseRequestCount: number;
  securitySetting: boolean;
  parentSecuritySetting: boolean;
  employeeSecuritySetting: boolean;
  mailboxConnectedEmails: string[];
  // payments: IPayment[];
  termsOfServiceLink: string | null;
  privacyPolicyLink: string | null;
  textGridSetting: ITextGridSetting;
  orgPhone: string | null;
  taxonomy?: string[];
}

export interface ITextGridSetting {
  accountSID: string; //sub-account SID
  authToken: string;
  webhookSecret: string;
  phoneNumber: string;
  status: TextGridStatus;
}

export enum TextGridStatus {
  Connected = "Connected",
  Pending = "Pending",
  Requested = "Requested",
}

export interface TextGridSetting {}

export interface ParentForm {
  id: string;
  name: string;
  url: string;
  embeddedCode: string;
  createdAt: string;
  updatedAt: string;
  isJot: boolean;
}

export interface Organization {
  dataChange: boolean;
  searchKeyword: string;
  orgData: OrgData;
}

// export interface CompanyUsersResponse {
//   id: string;
//   firstName: string;
//   lastName: string;
//   email: string;
//   role: string;
//   businessUnit: string;
//   //roleVal: any;
//   userProfile: {};
//   createdAt: string;
//   updatedAt: string;
//   status: string;
// }

// export interface UserResponse {
//   businessUnit: string;
//   email: string;
//   firstName: string;
//   id: string;
//   lastName: string;
//   orgId: string;
//   role: string;
//   createdAt: string;
//   updatedAt: string;
// }

export interface TimeZoneState {
  value: string;
  label: string;
  offset: number;
  abbrev: string;
  altName: string;
}

export interface OrgBU {
  id: string;
  businessUnitName: string;
  businessUnitAddress: string;
  businessUnitCity: string;
  businessUnitState: string;
  businessUnitZipCode: string;
  businessUnitTimeZone: TimeZoneState;
  claimLocation?: boolean;
  npi?: string;
  createdAt: string;
  updatedAt: string;
  tenantId: string;
}

export interface BusinessUnitInitialState {
  businessUnits: OrgBU[];
  dataChange: boolean;
}
